export const data = {
    name: "Plug And Abandon",
    layout: [],
};
export default data;